import angular from 'angular';
import constants from '../constants';
import appCache from './ApplicationCache';

export class GeoService {
  constructor(APIService, $q, $log) {
    "ngInject";
    this.APIService = APIService;
    this.$q = $q;
    this.$log = $log;
  }

  latLngLookup( coords ) {
    let config = {
      params: {
        latlng: coords
      }
    };

    return this.APIService.get('/geo/reverse_geocode', config);
  }

  placeSearch( coords, types, units ) {
    let config = {
      params: {
        types: types,
        radius: 300,
        units: units,
        location: coords
      }
    };

    return this.APIService.get('/geo/place_search', config);

  }

  placeDetail( place_id ) {
    let config = {
      params: {
        placeid: place_id
      }
    };

    return this.APIService.get('/geo/place_detail', config);

  }

}

export const moduleName = 'GeoService';

export let module = angular.module(moduleName, [
  constants,
  appCache.name
]);

module.service('GeoService', GeoService);

export default module;
